import { jsx as _jsx } from "react/jsx-runtime";
import { List } from "antd";
import { ErrorModalListItem } from ".";
const ErrorModalList = (param)=>{
    let { list } = param;
    return /*#__PURE__*/ _jsx(List, {
        size: "small",
        dataSource: Object.values(list),
        renderItem: (item)=>/*#__PURE__*/ _jsx(ErrorModalListItem, {
                item: item
            }, item.type)
    });
};
export { ErrorModalList };
